import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
    extra: {},
}

type State = typeof initialState

// Action types are derived from the reducer key via toUpperCase(), so they have no word separator.
const handlers = {
    SCHEDULEDTERMINATIONS_RECEIVE_LIST: receiveList,
    SCHEDULEDTERMINATIONS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_SCHEDULEDTERMINATIONS: changeEntity,
    INVALIDATE_SCHEDULEDTERMINATIONS: invalidateFilters,
    SCHEDULEDTERMINATIONS_REQUEST: (state: State) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

export default createReducer(initialState, handlers)
